import {
    LOAD_PRODUCTS_SUCCESS, RESET_PRODUCTS, REORDER_PRODUCTS_SUCCESS
} from '../../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case LOAD_PRODUCTS_SUCCESS:
            return action.payload;
        case REORDER_PRODUCTS_SUCCESS:
            return action.payload;
        case RESET_PRODUCTS:
            return INITIAL_STATE;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/posmenu/ProductsReducer.js